import { get as _get, post as _post } from '../../../utils/fetcher'
import i18n from '../../../imports/i18n.js'
import { mapDataForFairmatProductScore } from '../../../utils/drivers'
import { getField, updateField } from 'vuex-map-fields'
import { assetClassStorageKey } from '../../../utils/assetClassState'

export default {
  namespaced: true,
  state: {
    scoringProfilesList: [],
    productId: null,
    currentProfileId: null,
    scoringProfileId: null,
    productScore: null,
    productScoreInvestment: null,
    loadingProductScore: false,
    successOnAssociate: false,
    investmentOption: null,
    currentInvestmentOption: null,
    documentation: [],
  },

  mutations: {
    updateField,

    setScoringProfilesList(state, payload) {
      state.scoringProfilesList = payload
    },

    setCurrentInvestmentOption(state, payload) {
      state.currentInvestmentOption = payload
    },

    setCurrentProfileId(state, payload) {
      state.currentProfileId = payload
    },

    setProductId(state, payload) {
      state.productId = payload
    },

    setInvestmentOption(state, payload) {
      state.investmentOption = payload
    },

    setScoringProfileAssociate(state, payload) {
      state.scoringProfilesList.forEach((el) => {
        el.isAssociated = el.id === payload
      })
    },

    setProductScore(state, payload) {
      state.productScore = payload
    },

    setProductScoreInvestment(state, payload) {
      state.productScoreInvestment = payload
    },

    setLoadingProductScore(state) {
      state.loadingProductScore = true
    },

    resetLoadingProductScore(state) {
      state.loadingProductScore = false
    },

    setSuccessOnAssociate(state, payload) {
      state.successOnAssociate = payload
    },
    setDocumentation(state, payload) {
      const data = {
        productId: state.productId,
        documents: payload,
      }
      state.documentation.push(data)
    },
  },

  getters: {
    getField,

    getProductId(state) {
      return state.productId
    },
    getCurrentProfileId(state) {
      return state.currentProfileId
    },
    getScoringProfilesList(state) {
      return [{ id: null, name: i18n.t('common.none') }, ...state.scoringProfilesList]
    },
    getScoringProfileAssociated(state) {
      return state.scoringProfilesList.find((el) => el.isAssociated === true) || { id: null }
    },
    getProductScore(state) {
      return mapDataForFairmatProductScore({ ...state.productScore })
    },
    getProductScoreInvestment(state) {
      return mapDataForFairmatProductScore({ ...state.productScoreInvestment })
    },
    getLoadingProductScore(state) {
      return state.loadingProductScore
    },
    getExistingDocumentation(state) {
      return state.documentation
    },
  },

  actions: {
    loadProductScore({ state, commit }, { scoringProfileId, investmentOptionName }) {
      if (state.productId == null || scoringProfileId == null) {
        commit('setCurrentProfileId', null)
        commit('setProductScore', null)
        commit('setProductScoreInvestment', null)
        return
      }

      commit('setLoadingProductScore')

      const objData =
        investmentOptionName != null
          ? {
              productId: state.productId,
              scoringProfileId: scoringProfileId,
              investmentOptionName: investmentOptionName,
            }
          : {
              productId: state.productId,
              scoringProfileId: scoringProfileId,
            }

      const commit_name = investmentOptionName != null ? 'setProductScoreInvestment' : 'setProductScore'

      _post('/api/insights/score', objData).then((data) => {
        commit(commit_name, data)
        commit('resetLoadingProductScore')
        commit('setCurrentProfileId', scoringProfileId)
      })
    },

    changeScoringProfile({ commit, state, dispatch }, objData) {
      commit('setCurrentProfileId', objData.id)

      let endpoint = ''

      switch (objData.action) {
        case 'onAssociate':
          endpoint = `/api/benchmarking/associate/${state.productId}/${objData.id}`
          break
        case 'onSelect':
          endpoint = ''
          break
        case 'onRemove':
          endpoint = `/api/benchmarking/disassociate/${state.productId}`
          commit('setProductScore', null)
          commit('setProductScoreInvestment', null)
          break
        default:
          endpoint = ''
      }

      if (endpoint !== '') {
        _post(endpoint).then(() => {
          commit('setScoringProfileAssociate', objData.id)
          commit('setSuccessOnAssociate', objData.id != null && objData.action === 'onAssociate')
        })
      }
    },

    loadScoringProfiles({ commit, state }, productId) {
      commit('setProductId', productId)
      _get(`/api/benchmarking/scoringProfiles/${state.productId}`).then((data) => {
        commit('setScoringProfilesList', data)
        const associated = data.find((el) => el.isAssociated === true) || null
        const profileIdKey = assetClassStorageKey('currentScoringProfileId')
        if (localStorage.getItem(profileIdKey) != null) {
          commit('setCurrentProfileId', Number(localStorage.getItem(profileIdKey)))
        } else if (associated != null) {
          commit('setCurrentProfileId', associated.id)
        }
      })
    },

    loadProductInvestmentOptionDetail({ commit, state }, investmentOption) {
      commit('setInvestmentOption', investmentOption)
      return new Promise((resolve) => {
        _get(`/api/detail/investmentOption/${state.investmentOption}`).then((data) => {
          commit('setCurrentInvestmentOption', data)
          resolve(data)
        })
      })
    },

    loadProductDocumentation({ commit }, productInfo) {
      return new Promise((resolve) => {
        _post(`/api/detail/documents`, productInfo).then((data) => {
          commit('setDocumentation', data)
          resolve(data)
        })
      })
    },

    // Config-driven preset (PresetFiltersBuilder on the BE) — backs the
    // "+ Crea un nuovo profilo per questo prodotto" button (GET /api/benchmarking/filters/{id}).
    loadScoringProfileFilters({ commit }, idProduct) {
      return new Promise((resolve) => {
        _get(`/api/benchmarking/filters/${idProduct}`).then((data) => {
          resolve(data)
        })
      })
    },

    resetState({ state }) {
      state.scoringProfilesList = []
      state.productId = null
      state.currentProfileId = null
      state.scoringProfileId = null
      state.productScore = null
      state.productScoreInvestment = null
      state.loadingProductScore = false
      state.successOnAssociate = false
      state.investmentOption = null
      state.currentInvestmentOption = null
      state.documentation = []
    },
  },
}
